import OrdersApi from "../../services/api/Orders";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import { ORDER_STATE_LIVE } from "../../constants/Orders/States";

function handleError(err) {
  console.log("error in delivery drivers actions :", err);
}

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ORDERS_LIST_FILTERS,
    payload,
  };
};

export const setOrdersList = (payload) => {
  return {
    type: ActionTypes.SET_ORDERS_LIST,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_ORDERS_LIST_AND_FILTERS,
    payload,
  };
};

export const setOrderDetails = (payload) => {
  return {
    type: ActionTypes.SET_ORDER_DETAILS,
    payload,
  };
};

// resetOrderDetails
export const resetOrderDetails = (payload) => {
  return {
    type: ActionTypes.RESET_ORDER_DETAILS,
    payload,
  };
};

export const getOrdersList = (params) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    dispatch(setActiveFilters(params));
    const finalParams = { ...params };
    if ('page' in finalParams) {
      delete finalParams.page;
    }
    if (params?.addressFilter) {
      finalParams.addressFilter.page_no = 1;
      if (params?.page) {
        finalParams.addressFilter.page_no = params.page;
      }
      if (params?.addressFilter?.order_state == "") {
        finalParams.addressFilter.order_state = ORDER_STATE_LIVE;
      }
    } else  if (params?.driverIdFilter) {
      finalParams.driverIdFilter.page_no = 1;
      if (params?.page) {
        finalParams.driverIdFilter.page_no = params.page;
      }
    }
    let response = await OrdersApi.getOrdersList(finalParams);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setOrdersList(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getOrderDetails = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await OrdersApi.getOrdersDetails(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setOrderDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const forceComplete = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await OrdersApi.forceComplete(id, data);
    dispatch(setLoader(false));
    if (response) {
      return "success";
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const markOrderReady = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await OrdersApi.markOrderReady(id, data);
    dispatch(setLoader(false));
    if (response) {
      return "success";
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const unAssignOrder = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await OrdersApi.unAssign(id, data);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const reAssignOrder = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await OrdersApi.reAssign(id, data);
    dispatch(setLoader(false));
    if (response) {
      return "success";
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const cancel = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await OrdersApi.cancel(id, data);
    dispatch(setLoader(false));
    if (response) {
      return "success";
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getActionTypesWithReasons = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await OrdersApi.getActionTypesWithReasons(id);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};